import React from 'react';
import ApplicationForm from '../../components/Apply/ApplicationForm';
import './Apply.css';
import { useNavigate } from 'react-router-dom';

export default function Apply() {
  const navigate = useNavigate();
  return (
    <main className="apply-page">
      <div className="apply-container">
        <div className="apply-header">
          <button
            className="apply-back-btn"
            onClick={() => navigate(-1)}
          >
            &larr; Retour aux offres
          </button>
          <h1 className="apply-title">Postuler chez NEXUS SOLUTIONS</h1>
        </div>

        <div className="apply-notice">
          <span className="apply-notice__icon">✓</span>
          Nous repondons a toutes les candidatures sous <strong>5 jours ouvrables</strong>. Aucun dossier n'est ignore.
        </div>

        <p className="apply-subtitle">
          Remplissez le formulaire ci-dessous. Vous pouvez joindre votre CV (PDF ou DOCX) et une lettre de motivation.
        </p>

        <ApplicationForm />
      </div>
    </main>
  );
}
